import {createFileRoute, useParams} from '@tanstack/react-router'
import React from "react";
import CourtBookingPage from "../../../../bookings/CourtBookingPage.tsx";

export const Route = createFileRoute('/_app/clubs/$club_uid/courts-booking')({
    component: RouteComponent,
})

/** The club booking page: a slot picker of bookable start times and an instant Book flow. */
function RouteComponent() {
    const params = useParams({strict: false});

    return <CourtBookingPage clubUid={params.club_uid!} />;
}
